import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { RatingResponse } from '../../../models/review-insights-models/rating-response';
import { ReviewNumbersResponse } from '../../../models/review-insights-models/review-numbers-response';
import { LocationComparisonOverviewResponseEntry } from '../../../models/review-insights-models/location-comparison-overview-response-entry';
import { LocationComparisonResponseEntry } from '../../../models/review-insights-models/location-comparison-response-entry';
import { RespondedCommentedResponse } from '../../../models/review-insights-models/responded-commented-response';
import { ResponseTimesResponse } from '../../../models/review-insights-models/response-times-response';
import { ChartDatapointSeries } from '../../../models/review-insights-models/chart-datapoint-series';
import { ChartDatapoint } from '../../../models/review-insights-models/chart-datapoint';
import { MapLocationInterface } from '../../../models/review-insights-models/map-location';
import { ReviewInsightsFilterInterface } from '../../../models/review-insights-models/review-insights-filter';
import { LocationComparisonTableSettings } from '../../../models/review-insights-models/location-comparison-filter';
import { InsightsMethod } from '../../../models/review-insights-models/insights-method';

export const RatingActions = createActionGroup({
  source: 'INSIGHTS - RATING',
  events: {
    getRating: emptyProps(),
    getRatingSuccess: props<{ rating: RatingResponse }>(),
    getRatingFail: emptyProps(),
  },
});

export const ReviewNumbersActions = createActionGroup({
  source: 'INSIGHTS - REVIEW NUMBERS',
  events: {
    getReviewNumbers: emptyProps(),
    getReviewNumbersSuccess: props<{ reviewNumbers: ReviewNumbersResponse }>(),
    getReviewNumbersFail: emptyProps(),
  },
});

export const TopLocationsActions = createActionGroup({
  source: 'INSIGHTS - TOP LOCATIONS',
  events: {
    getTopLocations: emptyProps(),
    getTopLocationsSuccess: props<{ topLocations: LocationComparisonOverviewResponseEntry[] }>(),
    getTopLocationsFail: emptyProps(),
  },
});

export const LocationComparisonActions = createActionGroup({
  source: 'INSIGHTS - LOCATION COMPARISON',
  events: {
    getLocationComparisonList: emptyProps(),
    getLocationComparisonListSuccess: props<{
      locationComparisonList: LocationComparisonResponseEntry[]
    }>(),
    getLocationComparisonListFail: emptyProps(),
  },
});

export const LocationComparisonCountActions = createActionGroup({
  source: 'INSIGHTS - LOCATION COMPARISON COUNT',
  events: {
    getLocationComparisonCount: emptyProps(),
    getLocationComparisonCountSuccess: props<{ locationComparisonCount: number }>(),
    getLocationComparisonCountFail: emptyProps(),
  },
});

export const RespondedCommentedActions = createActionGroup({
  source: 'INSIGHTS - RESPONDED / COMMENTED',
  events: {
    getRespondedCommented: emptyProps(),
    getRespondedCommentedSuccess: props<{ respondedCommented: RespondedCommentedResponse }>(),
    getRespondedCommentedFail: emptyProps(),
  },
});

export const ResponseTimesActions = createActionGroup({
  source: 'INSIGHTS - RESPONSE TIMES',
  events: {
    getResponseTimes: emptyProps(),
    getResponseTimesSuccess: props<{ responseTimes: ResponseTimesResponse }>(),
    getResponseTimesFail: emptyProps(),
  },
});

export const ResponseTimesOverviewActions = createActionGroup({
  source: 'INSIGHTS - RESPONSE TIMES OVERVIEW',
  events: {
    getResponseTimesOverview: emptyProps(),
    getResponseTimesOverviewSuccess: props<{ responseTimesOverview: number }>(),
    getResponseTimesOverviewFail: emptyProps(),
  },
});

export const PostTimesActions = createActionGroup({
  source: 'INSIGHTS - POST TIMES',
  events: {
    getPostTimes: emptyProps(),
    getPostTimesSuccess: props<{ postTimes: ChartDatapointSeries[] }>(),
    getPostTimesFail: emptyProps(),
  },
});

export const PostsPerWeekdayActions = createActionGroup({
  source: 'INSIGHTS - POSTS PER WEEKDAY',
  events: {
    getPostsPerWeekday: emptyProps(),
    getPostsPerWeekdaySuccess: props<{ postsPerWeekday: ChartDatapoint[] }>(),
    getPostsPerWeekdayFail: emptyProps(),
  },
});

export const MapLocationsActions = createActionGroup({
  source: 'INSIGHTS - MAP LOCATIONS',
  events: {
    getMapLocations: props<{ ignoreFilters?: boolean }>(), // ignore filters 'coz we want all locations as there is FE filtering
    clearMapLocations: emptyProps(),
    getMapLocationsSuccess: props<{ mapLocations: MapLocationInterface[] }>(),
    getMapLocationsFail: emptyProps(),
  },
});

export const syncInsightsFilters = createAction('[INSIGHTS] Sync Filters',
    props<{ filters: ReviewInsightsFilterInterface, preventUpdate?: boolean }>());
export const syncLocationComparisonTableSettings = createAction('[INSIGHTS] Sync Location Comparison Table Settings',
    props<{
      locationComparisonTableSettings: LocationComparisonTableSettings,
      preventUpdate?: boolean
    }>());
export const updateFiltersForSuccessfulInsightsCall = createAction('[INSIGHTS] Update active filer values for a successful API call',
    props<{ filters: object, insightsMethod: InsightsMethod }>());
export const insightsComponentDestroyed = createAction('[INSIGHTS] Component Destroyed!');
